export default "__VITE_ASSET__d8d22f99__"